import {makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {ModalType, RequestState} from "data/enums";
import type {ILocalizationStore} from "data/stores/localization/localization.store";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {IModalMessage, TModalArguments} from "data/types/modals";
import type {IRoundsStore} from "data/stores/rounds/rounds.store";
import type {ITeamStore} from "data/stores/team/team.store";

export interface ITradesConfirmModalController extends ViewController {
	get i18n(): ILocalizationStore;
	get visibleModal(): ModalType | null;
	get modalContent(): IModalMessage | null;
	get isLoadingTeam(): boolean;

	close: () => void;
	show: (...args: TModalArguments) => void;
	onMakeTrades: () => void;
	onRollback: () => void;
}

@injectable()
export class TradesConfirmModalController implements ITradesConfirmModalController {
	@observable _requestState: RequestState = RequestState.IDLE;

	constructor(
		@inject(Bindings.ModalsStore) private _modalsStore: IModalsStore,
		@inject(Bindings.LocalizationStore) private _i18nStore: ILocalizationStore,
		@inject(Bindings.RoundsStore) private _roundStore: IRoundsStore,
		@inject(Bindings.TeamStore) private _teamStore: ITeamStore
	) {
		makeAutoObservable(this);
	}

	get i18n() {
		return this._i18nStore;
	}

	get visibleModal() {
		return this._modalsStore.modal;
	}

	get modalContent() {
		return this._modalsStore.modalContent;
	}

	get isLoadingTeam() {
		return this._teamStore.isLoadingTeam;
	}

	show = (...args: TModalArguments) => {
		this._modalsStore.showModal(...args);
	};

	close = () => this._modalsStore.hideModal();

	onMakeTrades = () => {
		void this._teamStore.makeTrades();
		this.close();
	};

	onRollback = () => {
		void this._teamStore.onRollbackLocal();
		this.close();
	};

	dispose() {
		return;
	}

	init(param: void) {
		return;
	}
}
